import { api } from "@/lib/api";

export const CAT = { loading_unloading: "Loading & Unloading", daily_labour: "Daily Labour", tiles_work: "Tiles Work", house_repair: "House Repair & Renovation" };
export const catText = (cats) => (cats || []).map((c) => CAT[c] || c).join(", ") || "—";

export const blobUrl = async (path, opts = {}) => {
  const r = await api.request({ url: path, method: opts.method || "get", data: opts.data, responseType: "blob" });
  return URL.createObjectURL(r.data);
};

export const downloadBlob = (url, name) => {
  const a = document.createElement("a"); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
};

// Prints a PDF at its native CR80 size via a hidden iframe (print at 100% / "Actual size").
export const printPdf = (url) => {
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  f.src = url;
  f.onload = () => { try { f.contentWindow.focus(); f.contentWindow.print(); } catch { window.open(url, "_blank"); } setTimeout(() => f.remove(), 60000); };
  document.body.appendChild(f);
};
